import { useOnboarding } from "@/hooks/use-onboarding"
import { IonContent, IonIcon, IonPage, IonRadio, IonRadioGroup, IonItem } from "@ionic/react"
import { informationCircleOutline } from "ionicons/icons"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import { mediumImpact } from "@/utils/capacitorUtils"

interface GenderSelectionProps {
  nextStep: string;
  setLoadingState?: (loading: boolean, hideHeader?: boolean) => void;
}

const GenderSelection: React.FC<GenderSelectionProps> = ({ nextStep, setLoadingState }) => {
  const { t } = useTranslation("MGP")
  const history = useHistory()
  const { updateOnboardingData } = useOnboarding()
  const [selectedGender, setSelectedGender] = useState<string>()

  const genderOptions = [
    { id: "1", name: "man" },
    { id: "2", name: "woman" },
    { id: "0", name: "prefer_not_to_say" },
  ]

  const handleGenderSelection = async () => {
    if (!selectedGender) return

    try {
      // Notify parent component about loading state
      setLoadingState?.(true);
      mediumImpact();
      
      await updateOnboardingData({ gender: selectedGender });
      
      // Reset loading state before navigation
      setLoadingState?.(false);
      history.push(nextStep);
    } catch (error) {
      console.error("Error updating gender selection:", error);
      // Reset loading state on error
      setLoadingState?.(false);
    }
  }

  return (
    <IonPage>
      <IonContent scrollY={false}>
        <div className="flex flex-col px-4 bg-card h-full max-w-2xl mx-auto">
          <h1 className="text-2xl font-bold mb-4">{t("gender_selection_title")}</h1>
          <div className="flex text-sm mb-6">
            <span>{t("select_your_gender_body")}</span>
            <IonIcon
              icon={informationCircleOutline}
              className="ml-2 cursor-help"
              onClick={() => alert(t("gender_selection_description"))}
            />
          </div>

          <div className="rounded-lg p-2 mb-8">
            <IonRadioGroup
              value={selectedGender}
              onIonChange={e => setSelectedGender(e.detail.value)}
              className="space-y-2"
            >
              {genderOptions.map((gender) => (
                <IonItem lines="none" key={gender.id} color="transparent" className="border border-input rounded-md mb-2">
                  <div className="flex items-center">
                    {t(gender.name)}
                  </div>
                  <IonRadio slot="end" value={gender.id} />
                </IonItem>
              ))}
            </IonRadioGroup>
          </div>

          <div className="mt-auto mb-8">
            <button
              onClick={handleGenderSelection}
              disabled={!selectedGender}
              className={`w-full py-3 px-4 rounded-full font-medium text-white ${selectedGender ? 'bg-primary' : 'bg-primary/50'}`}
            >
              {t("next")}
            </button>
          </div>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default GenderSelection

